import { render, staticRenderFns } from "./ckEditor.vue?vue&type=template&id=d6b37008&"
import script from "./ckEditor.vue?vue&type=script&lang=js&"
export * from "./ckEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports